var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "text-xs-center": "", m0a: "" } },
            [
              _c("label", [_c("h2", [_vm._v("Date Range")])]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", m0a: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.availableProductTypes,
                      chips: "",
                      clearable: "",
                      label: "Filter Types",
                      multiple: ""
                    },
                    model: {
                      value: _vm.enableProductTypes,
                      callback: function($$v) {
                        _vm.enableProductTypes = $$v
                      },
                      expression: "enableProductTypes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", m0a: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "max-width": "320px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        label: "Date from",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: ""
                                      },
                                      model: {
                                        value: _vm.dateFrom,
                                        callback: function($$v) {
                                          _vm.dateFrom = $$v
                                        },
                                        expression: "dateFrom"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.menu1,
                        callback: function($$v) {
                          _vm.menu1 = $$v
                        },
                        expression: "menu1"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: { max: new Date().toISOString().substr(0, 10) },
                        on: {
                          input: function($event) {
                            _vm.menu1 = false
                          }
                        },
                        model: {
                          value: _vm.dateFrom,
                          callback: function($$v) {
                            _vm.dateFrom = $$v
                          },
                          expression: "dateFrom"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", m0a: "" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "max-width": "320px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        label: "Date to",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: ""
                                      },
                                      model: {
                                        value: _vm.dateTo,
                                        callback: function($$v) {
                                          _vm.dateTo = $$v
                                        },
                                        expression: "dateTo"
                                      }
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: {
                          min: _vm.dateFrom,
                          max: new Date().toISOString().substr(0, 10)
                        },
                        on: {
                          input: function($event) {
                            _vm.menu1 = false
                          }
                        },
                        model: {
                          value: _vm.dateTo,
                          callback: function($$v) {
                            _vm.dateTo = $$v
                          },
                          expression: "dateTo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs6: "", m0a: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.getRecords()
                        }
                      }
                    },
                    [_vm._v(" Get Records ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.items.length > 0 && _vm.showData === true
            ? _c(
                "v-flex",
                { attrs: { xs8: "", "text-xs-center": "", m0a: "" } },
                [
                  _c(
                    "table",
                    { staticClass: "itemRecords", attrs: { width: "100%" } },
                    [
                      _c("tr", [
                        _c("th", [_vm._v("Item Type")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Total Items")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Total Amount")])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.items, function(item, index) {
                        return _c(
                          "tr",
                          { key: index, staticClass: "text-xs-center" },
                          [
                            _c("td", [_vm._v(_vm._s(item[0]))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item[1]))]),
                            _vm._v(" "),
                            _c("td", [_vm._v("$" + _vm._s(item[2]))])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.items.length === 0 && _vm.showData === true
            ? _c(
                "v-flex",
                { attrs: { xs8: "", "text-xs-center": "", m0a: "" } },
                [_vm._v("\n      No Record found.\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showData === false
            ? _c(
                "v-flex",
                { attrs: { xs8: "", "text-xs-center": "", m0a: "" } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8a2b3f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8a2b3f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/OrderDetails.vue
// module id = null
// module chunks = 